import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "./Button";
import Metalprice from "./Metalprice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faPhone, faEnvelope } from "@fortawesome/free-solid-svg-icons";

const CallAction = () => {
  return (
    <section className="cta-section">
      <Container>
        <Row className="align-items-center">
          <Col lg={7} className="cta-content">
            <span className="cta-label">Ready to Transform?</span>
            <h2 className="cta-title">
              Unleash Your Products' True Potential Today
            </h2>
            <p className="cta-description">
              Experience the ultimate transformation with our premium electroplating services.
              Get a free consultation and quote from our expert team.
            </p>
            <div className="cta-buttons">
              <Button to="/contact" variant="primary" size="lg">
                Get Started <FontAwesomeIcon icon={faArrowRight} className="ms-2" />
              </Button>
              <div className="cta-contact-info">
                <a href="tel:+96103518323" className="cta-contact-link">
                  <FontAwesomeIcon icon={faPhone} />
                  <span>+961 03 518 323</span>
                </a>
                <a href="mailto:ralphkamel.rk@gmail.com" className="cta-contact-link">
                  <FontAwesomeIcon icon={faEnvelope} />
                  <span>Email Us</span>
                </a>
              </div>
            </div>
          </Col>
          <Col lg={5} className="cta-metal-price">
            <Metalprice />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default CallAction;
